import usePlatforms from '@/helpers/usePlatforms';
import { computed, ComputedRef, inject } from 'vue';
import usePortfolio from '../../usePortfolio';
import { Dataset, IChartInterface } from './ChartInterface';
import { handleOther } from './helpers';

export default function usePlatformData(): IChartInterface {
  const { portfolioInfo } = inject('portfolioData') as ReturnType<
    typeof usePortfolio
  >;

  const { getPlatformById } = usePlatforms();

  const total = computed(() => {
    const holding = portfolioInfo.assetWalletTokens.value.reduce(
      (sum, value) => sum + (value.value ?? 0),
      0,
    );
    const platform = portfolioInfo.elementsByPlatformId.value.reduce(
      (sum, value) => sum + value.value,
      0,
    );
    return holding + platform;
  });

  const dataset: ComputedRef<Dataset[]> = computed(() => {
    const data: Dataset[] = [];

    // Holding
    const holding = {
      name: 'Holdings',
      value: 0,
      pourcent: 100,
    };
    portfolioInfo.assetWalletTokens.value.forEach((e) => {
      holding.value += e.value ?? 0;
    });
    holding.pourcent = (holding.value / total.value) * 100;
    if (holding.value > 0) {
      data.push(holding);
    }

    // Platform
    portfolioInfo.elementsByPlatformId.value.forEach((e) => {
      data.push({
        name: getPlatformById(e.platformId)?.name ?? 'Error',
        value: e.value,
        pourcent: (e.value / total.value) * 100,
      });
    });

    return handleOther(
      data.sort((a, b) => b.value - a.value),
      5,
      total.value,
    );
  });

  return {
    dataset,
    total,
  };
}
